import Vue from 'vue'
import Router from 'vue-router'
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Datepicker from 'vuejs-datepicker'


//FC-One
// import login from '@/components/login'
import collections from '@/components/collections'
import designsummry from '@/components/designsummry'
import sampling_requested from '@/components/sampling_requested'
import sampling_approved from '@/components/sampling_approved'
import sampling_inprogress from '@/components/sampling_inprogress'
import orders from '@/components/orders'
import production from '@/components/production'
import message from '@/components/message'
import designs from '@/components/designs'
import home from '@/components/home'
import design_dashboard from '@/components/designs_dashboard.vue'
import allrecords from '@/components/allrecords'
import approved from '@/components/approved'
import notapproved from '@/components/notapproved'

import usersdetails from '@/components/usersdetails'
import mybranddetails from '@/components/mybranddetails'
import updateProfile from '@/components/updateProfile.vue'

import designs_list from '@/components/designs_list.vue'


import brands from '@/components/brands.vue'

import dashboard from '@/components/dashboard.vue'

import addusersdetails from '@/components/addusersdetails.vue'
import manage_brands from '@/components/manage_brands.vue'

import design_details from '@/components/design_details.vue'
import design_files from '@/components/design_files.vue'
import design_quotes from '@/components/design_quotes.vue'
import design_samples from '@/components/design_samples.vue'
import color_finder from '@/components/color_finder.vue'
import newquotation from '@/components/newquotation.vue'
import addnewquotation from '@/components/addnewquotation.vue'
import style_list from '@/components/style_list.vue'
import quality_details from '@/components/quality_details.vue'
import requested_quotation from '@/components/requested_quotation.vue'

import orderslisting from '@/components/orderslisting'
import styles from '@/components/styles'
import creadted from '@/components/creadted'
import quotition from '@/components/quotition'

import samplelisting from '@/components/samplelisting'
import productionlist from '@/components/productionlist'
import fittech_list from '@/components/fittech_list'
import fittech_log from '@/components/fittech_log'
import loadingpage from '@/components/loadingpage'
import designer_details_list from '@/components/designer_details_list'
import dashboard_quality from '@/components/dashboard_quality'
import graphics_designer from '@/components/graphics_designer'
import create_artwork from '@/components/create_artwork'

import dashboard_brand_manager from '@/components/dashboard_brand_manager'
import dashboard_buyer from '@/components/dashboard_buyer'
import dashboard_designhead from '@/components/dashboard_designhead'
import dashboard_fit_tech from '@/components/dashboard_fit_tech'
import qualitycontroller_list from '@/components/qualitycontroller_list'
import samplingDetails from '@/components/samplingDetails'
import dashboard_designer from '@/components/dashboard_designer'
import design_purchaseorder from '@/components/design_purchaseorder'
import design_po_tna from '@/components/design_po_tna'
import design_po_reports from '@/components/design_po_reports'
import style_message from '@/components/style_message'
// import style_collection_old from '@/components/style_collection_old.vue'
// import style_collection_new from '@/components/style_collection_new.vue'
import style_collection_new_updated from '@/components/style_collection_new_updated.vue'
import marginmaster from '@/components/marginmaster.vue'
import dashboard_quality_executive from '@/components/dashboard_quality_executive.vue'
import qc_executive_tna from '@/components/qc_executive_tna.vue'
import qcvendorslist from '@/components/qcvendorslist.vue'
import new_message_design from '@/components/new_message_design.vue'
import searchrecords from '@/components/searchrecords.vue'
import dashboard_brandwise from '@/components/dashboard_brandwise.vue'
import dashboard_admin_brand from '@/components/dashboard_admin_brand.vue'
import updateuserdetails from '@/components/updateuserdetails.vue'
import inspectionTimeWindow from '@/components/inspectionTimeWindow.vue'
import ordersheet from '@/components/ordersheet.vue'
import mccreport from '@/components/mccreport.vue'
import misreport from '@/components/misreport.vue'
import qc_inspection from '@/components/qc_inspection.vue'
import allocate_inspection from '@/components/allocate_inspection'
import stylelist_for_qc from '@/components/stylelist_for_qc'
import uploadBomFile from '@/components/uploadBomFile'
import misreport_planner from '@/components/misreport_planner'
import upload_plan from '@/components/upload_plan'
import camsLogin from '@/components/camsLogin'

import dashboard_buyingHead from '@/components/dashboard_buyingHead'
import grade_minmax from '@/components/grade_minmax'
import me_dashboard from '@/components/me_dashboard'
import style_listmeuser from '../components/style_listmeuser.vue'
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
//const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
//const Home () => import('@/views/pages/Home')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

const router = new Router({
  base: process.env.VUE_APP_PUBLIC_URL,
  mode: 'history', // https://router.vuejs.org/api/#mode hash
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: '/cams_login',
      component: camsLogin

    },
    {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: '/design_dashboard',
        name: '/design_dashboard',
        component: design_dashboard
      },
      {
        path: '/collections',
        name: '/collections',
        component: collections

      },

      {
        path: '/sampling_requested',
        name: '/sampling_requested',
        component: sampling_requested

      },
      {
        path: '/sampling_approved',
        name: '/sampling_approved',
        component: sampling_approved

      },
      {
        path: '/sampling_inprogress',
        name: '/sampling_inprogress',
        component: sampling_inprogress

      },


      {
        path: '/design_details/:id?',
        name: '/design_details',
        component: design_details
      },

      {
        path: '/design_files/:id?',
        name: '/design_files',
        component: design_files
      },

      {
        path: '/design_quotes/:id?',
        name: '/design_quotes',
        component: design_quotes
      },

      {
        path: '/design_samples/:id?',
        name: '/design_samples',
        component: design_samples
      },

      {
        path: '/approved',
        name: '/approved',
        component: approved

      },
      {
        path: '/notapproved',
        name: '/notapproved',
        component: notapproved

      },
      {
        path: '/allrecords',
        name: '/allrecords',
        component: allrecords

      },
      {
        path: '/usersdetails',
        name: '/usersdetails',
        component: usersdetails
      },
      {
        path: '/mybranddetails',
        name: '/mybranddetails',
        component: mybranddetails
      },
      {
        path: '/updateProfile',
        name: '/updateProfile',
        component: updateProfile
      },

      {
        path: '/designs_list/:id?',
        name: '/designs_list',
        component: designs_list
      },
      {
        path: '/brands',
        name: '/brands',
        component: brands
      },

      {
        path: '/dashboard/:id?',
        name: '/dashboard',
        component: dashboard
      },


      {
        path: '/addusersdetails',
        name: '/addusersdetails',
        component: addusersdetails
      },

      {
        path: '/manage_brands',
        name: '/manage_brands',
        component: manage_brands
      },

      {
        path: '/color_finder',
        name: '/color_finder',
        component: color_finder
      },

      {
        path: '/newquotation',
        name: '/newquotation',
        component: newquotation
      },

      {
        path: '/addnewquotation',
        name: '/addnewquotation',
        component: addnewquotation
      },

      {
        path: '/style_list/:id?',
        name: '/style_list',
        component: style_list
      },

      {
        path: '/quality_details',
        name: '/quality_details',
        component: quality_details
      },

      {
        path: '/requested_quotation/:id?',
        name: '/requested_quotation',
        component: requested_quotation
      },

      {
        path: '/orderslisting',
        name: 'orderslisting',
        component: orderslisting

      },
      {
        path: '/styles',
        name: 'styles',
        component: styles

      },
      {
        path: '/creadted',
        name: 'creadted',
        component: creadted

      },
      {
        path: '/quotition',
        name: 'quotition',
        component: quotition

      },
      {
        path: '/samplelisting',
        name: 'samplelisting',
        component: samplelisting

      },
      {
        path: '/productionlist',
        name: 'productionlist',
        component: productionlist

      },
      {
        path: '/fittech_list',
        name: 'fittech_list',
        component: fittech_list

      },



      {
        path: '/loadingpage',
        name: 'loadingpage',
        component: loadingpage

      },
      {
        path: '/designer_details_list',
        name: 'designer_details_list',
        component: designer_details_list

      },
      {
        path: '/dashboard_quality',
        name: 'dashboard_quality',
        component: dashboard_quality

      },
      {

        path: '/graphics_designer',
        name: 'graphics_designer',
        component: graphics_designer

      },
      {

        path: '/create_artwork',
        name: 'create_artwork',
        component: create_artwork

      },
      {
        path: '/dashboard_brand_manager',
        name: 'dashboard_brand_manager',
        component: dashboard_brand_manager

      },
      {
        path: '/dashboard_buyer',
        name: 'dashboard_buyer',
        component: dashboard_buyer

      },
      {
        path: '/dashboard_designhead',
        name: 'dashboard_designhead',
        component: dashboard_designhead

      },
      {
        path: '/dashboard_fit_tech',
        name: 'dashboard_fit_tech',
        component: dashboard_fit_tech

      },
      {
        path: '/qualitycontroller_list',
        name: 'qualitycontroller_list',
        component: qualitycontroller_list

      },
      {
        path: '/samplingDetails',
        name: 'samplingDetails',
        component: samplingDetails

      },
      {
        path: '/dashboard_designer',
        name: 'dashboard_designer',
        component: dashboard_designer

      },
      {
        path: '/design_purchaseorder/:id?',
        name: 'design_purchaseorder',
        component: design_purchaseorder

      },
      {
        path: '/design_po_tna/:id?',
        name: 'design_po_tna',
        component: design_po_tna

      },
      {
        path: '/design_po_reports/:id?',
        name: 'design_po_reports',
        component: design_po_reports

      },
      {
        path: '/style_message/:id?',
        name: 'style_message',
        component: style_message

      },


      {
        path: '/style_collection_new_updated/:id/:user_id/:cat_id/:brand_id?',
        name: 'style_collection_new_updated',
        component: style_collection_new_updated

      },

      {
        path: '/marginmaster',
        name: 'marginmaster',
        component: marginmaster

      },

      {
        path: '/designsummry/:id?',
        name: 'designsummry',
        component: designsummry

      },
      {
        path: '/dashboard_quality_executive',
        name: 'dashboard_quality_executive',
        component: dashboard_quality_executive

      },
      {
        path: '/qc_executive_tna/:id?',
        name: 'qc_executive_tna',
        component: qc_executive_tna

      },
      {
        path: '/qcvendorslist',
        name: 'qcvendorslist',
        component: qcvendorslist

      },
      {
        path: '/new_message_design',
        name: 'new_message_design',
        component: new_message_design

      },
      {
        path: '/searchrecords',
        name: 'searchrecords',
        component: searchrecords

      },
      {
        path: '/dashboard_brandwise',
        name: 'dashboard_brandwise',
        component: dashboard_brandwise

      },
      {
        path: '/dashboard_admin_brand',
        name: 'dashboard_admin_brand',
        component: dashboard_admin_brand

      },
      {
        path: '/updateuserdetails/:id?',
        name: 'updateuserdetails',
        component: updateuserdetails

      },
      {
        path: '/inspectionTimeWindow',
        name: '/inspectionTimeWindow',
        component: inspectionTimeWindow

      },

      {
        path: '/ordersheet',
        name: '/ordersheet',
        component: ordersheet
      },

      {
        path: '/mccreport',
        name: '/mccreport',
        component: mccreport
      },

      {
        path: '/misreport',
        name: 'misreport',
        component: misreport

      },

      {
        path: '/qc_inspection/:id',
        name: '/qc_inspection',
        component: qc_inspection

      },
      {
        path: '/allocate_inspection',
        name: '/allocate_inspection',
        component: allocate_inspection
      },

      {
        path: '/allocate_inspection/:id',
        name: '/allocate_inspection',
        component: allocate_inspection
      },

      {
        path: '/fittech_log',
        name: '/fittech_log',
        component: fittech_log,

      },
      {
        path: '/stylelist_for_qc/:id',
        name: '/stylelist_for_qc',
        component: stylelist_for_qc
      },

      {
        path: '/uploadBomFile',
        name: '/uploadBomFile',
        component: uploadBomFile

      },

      { 
        path: '/misreport_planner',
        name: '/misreport_planner',
        component: misreport_planner
      },
    
      {           
        path: '/upload_plan',
        name: '/upload_plan',
        component: upload_plan

      },

    // dashboard_buyingHead
      
      {           
        path: '/dashboard_buyingHead',
        name: '/dashboard_buyingHead',
        component: dashboard_buyingHead

      },

    // grade_minmax
    {           
      path: '/grade_minmax',
      name: '/grade_minmax',
      component: grade_minmax

    },
    {
      path: '/me_dashboard',
      name: "me_dashboard",
      component: me_dashboard
    },
    {
      path: '/style_listmeuser/:id?',
      name: 'style_listmeuser',
      component: style_listmeuser,
      props: true
    }
    ]
    },
    // {
    // path: '/login',
    // name: 'login',
    // component: login
    // },

    {
      path: '/cams_login',
      name: '/cams_login',
      component: camsLogin
    },

    
    
  ]
})
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
function requireAuth(to, from, next) {
  var chkauth = auth.loggedIn()
  if (!auth.loggedIn()) {
    next({
      path: '/design_dashboard'
    })
  } else {
    next()
  }
}

function requireAuthCod(to, from, next) {
  const axios = require('axios')
  //console.log('url:',CONSTANTS.API_URL);
  axios.post(`${CONSTANTS.API_URL}/ValidateSystemUserLogin`, { sysemailid: "p2pcod@xpressbees.com", syspassword: "$p2pcod$" })
    .then(response => {
      if (response.data.returnmsg === 'successful') {
        let userData = response.data.returnvalue[0];
        console.log('data: ', userData);
        localStorage.setItem('userData', JSON.stringify(userData))
        localStorage.setItem('Coduser', "codvaliduser")
        var d1 = new Date()
        localStorage.setItem('activeTime', d1.getMinutes())
        Vue.http.headers.common['x-access-token'] = userInfo[0]['token'];
        next()
      }
    })
}